<template>
	<div class="login_open_link">
		<p>______________________</p>
		<input type="text" v-model="cart_preset_id">
		<button @click="saveCartPreset">שמירת עגלה ללינק</button>
		<button @click="loadCartPreset">TEST</button>
	</div>
</template>

<script>
	import Vuex from 'vuex';
	export default {
		name: 'SaveCartPreset',
		data () {
			return {
				cart: this.$store.state.added,
				ajaxUrl: window.wpData.ajax_url,
				cdnPath: window.wpData.CARMELLA_CDN_ROOT_URL + '/wp-content/themes/carmella/cache/products/',
				cart_preset_id: ''
			}
		},
		methods: {
			...Vuex.mapMutations([ "clearCart" ]),
			generateJSON(){
				console.log(this.$store.state.added);
				const items = [];
				this.cart.forEach( item => {
					delete item.relatedProducts;
					items.push(item);
				});
				return items;
			},
			saveCartPreset(){
				let formData = new FormData();
				formData.append('data', JSON.stringify(this.generateJSON()));

				if ( this.cart_preset_id ) {
					formData.append('cart_preset_id', this.cart_preset_id);
				}

				const request = fetch( this.ajaxUrl + '?action=ccp_saveCart', {
					method: 'POST',
					cache: 'no-cache',
					body: formData
				});
				request.then( r => r.json() )
					.then( data => {
						alert('done');
					});
			},
			loadCartPreset(){
				const request = fetch( this.ajaxUrl + '?action=ccp_getCartById&id=' + this.cart_preset_id, {
					method: 'get',
					cache: 'no-cache'
				});
				request.then( r => r.json() )
					.then( data => {
						const cartItems = data.data;
						// this.clearCart();
						const mergedProducts = [ ...this.$store.state.added, ...cartItems ];
						this.$store.state.added = mergedProducts;
						this.$store.dispatch('sendCartToServer');
					});
			}
		}
	}
</script>

<style lang="sass" scoped>
</style>